const e = {
  "loader-container": "_loader-container_h71w7_1"
};
export {
  e as default
};
//# sourceMappingURL=index.es5839.js.map
